
import RegisterAgree from '@/views/registerAgree.vue';
export default [
  //    {
  //   path: '/h5/',
  //   name: '网站首页',
  //   redirect:'/h5/index'
  // },
  {
    path: 'mapService',
    name: '检测机构查询地图',
    component: () => import('@/views/h5/testing/mapQuery.vue')
  },
{
    path: 'testOrganization',
    name: '',
    component: () => import('@/views/h5/testing/jcOrganization.vue')
  },
  {
    path: 'hbzcx',
    name: '移动端标准查询',
    component: () => import('@/views/h5/testing/bzcx/hbzcx.vue')
  },
  {
    path: 'hxlcx',
    name: '移动端限量查询',
    component: () => import('@/views/h5/testing/bzcx/hxlcx.vue')
  },

  {
    path: 'index',
    name: '移动端首页',
    component: () => import('@/views/h5/indexH5.vue')
  },
  {
    path: 'standardService',
    name: '移动端标准服务',
    component: () => import('@/views/h5/standardServiceH5.vue')
  },
  {
    path: 'testService',
    name: '移动端检测服务',
    component: () => import('@/views/h5/testServiceH5.vue')
  },
  {
    path: 'QualityEvaluation',
    name: '移动端品质评价',
    component: () => import('@/views/h5/qualityEvaluationServiceH5.vue')
  },
  {
    path: 'framework',
    name: '1+3体系H5',
    component: () => import('@/views/h5/homePages/framework.vue')
  },
  {
    path: 'aboutUsH5',
    name: '关于我们H5',
    component: () => import('@/views/h5/homePages/aboutUsH5.vue')
  },
  {
    path: 'evaluationSearch',
    name: '',
    component: () => import('@/views/h5/testing/evaluationSearch.vue')
  },
  {
    path: 'productSearchdetails',
    name: '',
    component: () => import('@/views/h5/testing/productSearchdetails.vue')
  }, 
  {
    name: { label: "隐私政策声明", moduleName: "隐私政策声明" },
    path: "privacyPolicy", component: RegisterAgree
  },
  {
    name: { label: "法律声明", moduleName: "法律声明" },
    path: "legaNotice", component: RegisterAgree
  }
]